module.exports = __webpack_public_path__ + "static/media/JCIE.6fee5fd3.jpg";